import { CommonModule } from '@angular/common';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { Router,RouterModule } from '@angular/router';


interface QuickApplicationItem {
  id: number;
  name: string;
  description: string;
  logoUrl: string;
  route: string;
  url:string;
}


@Component({
    selector: 'app-dashboard',
    standalone: false,
    templateUrl: './dashboard-company.html',
    styleUrl: './dashboard-company.css'
})
export class DashboardCompany {


      public companyName: string = 'Anameta Teknoloji A.Ş.';

  public companyType: string = 'Kurumsal Müşteri';

  public packageName: string = 'Enterprise';

  public activeUserCount: number = 24;

  public userLimit: number = 50;

  public subscriptionStatus: string = 'Aktif';

  public subscriptionExpireDate: string = '12 Mar 2026';

    projects = [
        {
            shortName: 'DO',
            name: 'Digital Observability',
            description: 'Monitoring, telemetry ve sistem gözlemlenebilirliği.',
            type: 'Web App',
            status: 'Aktif',
            statusClass: 'project-status-active',
            colorClass: 'project-red'
        },
        {
            shortName: 'LS',
            name: 'Login System',
            description: 'Merkezi kullanıcı kimlik doğrulama sistemi.',
            type: 'API',
            status: 'Aktif',
            statusClass: 'project-status-active',
            colorClass: 'project-blue'
        },
        {
            shortName: 'AI',
            name: 'AI Services',
            description: 'ANAMETA yapay zeka servis altyapısı.',
            type: 'Service',
            status: 'Geliştirme',
            statusClass: 'project-status-development',
            colorClass: 'project-purple'
        },
        {
            shortName: 'ONE',
            name: 'ANAMETA ONE',
            description: 'Tüm ANAMETA uygulamaları için merkezi portal.',
            type: 'Web App',
            status: 'Aktif',
            statusClass: 'project-status-active',
            colorClass: 'project-green'
        }
    ];

    chartValues: number[] = [
        42,
        61,
        48,
        72,
        58,
        79,
        94
    ];

    constructor(private router: Router) {

    }



    //FAST ACCESS
      @ViewChild('scrollViewport')
  private readonly scrollViewport?: ElementRef<HTMLDivElement>;

  public title: string = 'Uygulamalarınız';

  public subTitle: string =
    'Günlük iş akışınız için sık kullandığınız uygulamalara hızlı erişim.';

  public viewAllText: string = 'Tüm Uygulamalar';

  public quickApplications: QuickApplicationItem[] = [
  {
    id: 1,
    name: 'AI Portal',
    description: 'Yapay zeka çözümleri',
    logoUrl: '/assets/apps/ai-portal.png',
    route: '/applications/ai-portal',
    url:''
  },
  {
    id: 2,
    name: 'Observability',
    description: 'Sistem izleme ve analiz',
    logoUrl: '/assets/apps/observability.png',
    route: '/applications/observability',
    url:''
  },
  {
    id: 3,
    name: 'Login System',
    description: 'Kimlik ve erişim yönetimi',
    logoUrl: '/assets/apps/login-system.png',
    route: '/applications/login-system',
    url:''
  },

];

  public canScrollLeft: boolean = false;
  public canScrollRight: boolean = true;

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.updateScrollButtons();
    }, 0);
  }

  public ScrollLeft(): void {
    const container = this.scrollViewport?.nativeElement;

    if (!container) {
      return;
    }

    container.scrollBy({
      left: -320,
      behavior: 'smooth'
    });

    window.setTimeout(() => {
      this.updateScrollButtons();
    }, 300);
  }

  public ScrollRight(): void {
    const container = this.scrollViewport?.nativeElement;

    if (!container) {
      return;
    }

    container.scrollBy({
      left: 320,
      behavior: 'smooth'
    });

    window.setTimeout(() => {
      this.updateScrollButtons();
    }, 300);
  }

  public OnScroll(): void {
    this.updateScrollButtons();
  }

  public OpenAllApplications(): void {
    console.log('Tüm uygulamalar açılacak.');
  }

public OpenApplication(item: QuickApplicationItem): void {

    if (!item?.id) return;

       this.router.navigate(['/application', item.id]);
}

  public trackByApplication(index: number, item: QuickApplicationItem): number {
    return item.id;
  }

  private updateScrollButtons(): void {
    const container = this.scrollViewport?.nativeElement;

    if (!container) {
      this.canScrollLeft = false;
      this.canScrollRight = false;
      return;
    }

    this.canScrollLeft = container.scrollLeft > 5;

    this.canScrollRight =
      container.scrollLeft + container.clientWidth < container.scrollWidth - 5;
  }
}